import { GTBookingTicketCancelationReason } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const cancelBookingReasonMessages = defineMessages({
  [GTBookingTicketCancelationReason.Fraud]: {
    id: 'booking.cancellation.reason.fraud',
    defaultMessage: 'Fraude'
  },
  [GTBookingTicketCancelationReason.NoShow]: {
    id: 'booking.cancellation.reason.noShow',
    defaultMessage: 'No show'
  },
  [GTBookingTicketCancelationReason.Operational]: {
    id: 'booking.cancellation.reason.operational',
    defaultMessage: 'Operativo'
  },
  [GTBookingTicketCancelationReason.Personal]: {
    id: 'booking.cancellation.reason.personal',
    defaultMessage: 'Personal'
  },
  [GTBookingTicketCancelationReason.Test]: {
    id: 'booking.cancellation.reason.test',
    defaultMessage: 'Pruebas'
  },
  [GTBookingTicketCancelationReason.TripChange]: {
    id: 'booking.cancellation.reason.tripChange',
    defaultMessage: 'Cambio'
  }
})
